import React from "react";
import { FormControl, FormHelperText, Input, MenuItem, Select } from "@mui/material";
import { change as inputChange } from "redux-form";
import { useDispatch } from "react-redux";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const RenderMultiSelectField = ({
  input: { name, value, onChange, ...restInput },
  label,
  children,
  classes,
  inputLabelText,
  formControlClass,
  hasChips,
  meta: { dirty, invalid, error },
  ...custom
}) => {
  const [selectedValue, setSelectedValue] = React.useState([]);
  const dispatch = useDispatch();

  const handleChange = (event) => {
    dispatch(inputChange("donation", event.target.name, event.target.value));
    setSelectedValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <FormControl variant="standard" className={formControlClass} error={dirty && invalid}>
      <Select
        variant="standard"
        labelId={inputLabelText}
        id="demo-mutiple-chip"
        multiple
        name={name}
        displayEmpty
        value={selectedValue}
        onChange={handleChange}
        classes={{
          select: classes.multiSelect,
          root: classes.root,
          icon: classes.icon,
        }}
        input={<Input />}
        renderValue={(selected) => {
          if (selectedValue.length === 0) {
            return String(inputLabelText);
          }
          return selected.join(", ");
        }}
        MenuProps={MenuProps}>
        <MenuItem value="" disabled>
          {inputLabelText}
        </MenuItem>
        {children.map((child) => (
          <MenuItem key={child.label} value={child.value}>
            {child.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{dirty && error}</FormHelperText>
    </FormControl>
  );
};

export default RenderMultiSelectField;
